@use "sass:color";
@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.schoolAdminsDataTableContainer {
  padding: variables.$std-padding-sm;
}

.newSchoolAdminContainer {
  background-color: color.adjust(#8bc34a, $lightness: 20%);
  font-weight: bold;
  color: color.adjust(#8bc34a, $lightness: -20%);
  padding: variables.$std-padding-md;
  margin-bottom: variables.$std-margin-sm;
}

.actionBarStyle {
  margin-bottom: variables.$std-margin-lg;

  button + a {
    margin-left: variables.$std-margin-md;
  }
}
